import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { GenericDocContainerModel } from 'blg-akaun-ts-lib';
import { SubSink } from 'subsink2';
import { Observable } from 'rxjs';
import { SharedUtilitiesHelperFunctions } from '../helper-functions';

@Component({
  selector: 'app-util-generic-document-view-settlement',
  templateUrl: './generic-document-view-settlement.component.html',
  styleUrls: ['./generic-document-view-settlement.component.css']
})
export class GenericDocumentViewSettlementComponent implements OnInit, OnDestroy {
  @Input() genericDoc$: Observable<any>;
  @Input() localState: any;
  protected subs = new SubSink();

  defaultColDef = {
    filter: 'agTextColumnFilter',
    floatingFilterComponentParams: {suppressFilterButton: true},
    minWidth: 100,
    flex: 1,
    sortable: true,
    resizable: true,
    suppressCsvExport: true,
    floatingFilter: true
  };

  genericDoc: GenericDocContainerModel;
  gridApi;
  rowData: [];

  columnsDefs = [
    {headerName: 'Settlement Code', field: 'item_code', cellStyle: {'text-align': 'left'}},
    {headerName: 'Settlement Name', field: 'item_name', cellStyle: {'text-align': 'left'}},
    {headerName: 'Settlement Remarks', field: 'item_remarks', cellStyle: {'text-align': 'left'}},
    {headerName: 'Amount Txn', field: 'amount_txn', type: 'numericColumn',
      valueFormatter: params => params.value ? SharedUtilitiesHelperFunctions.currencyFormatter(params.value) : '0.00'},
  ];

  ccyCode;
  total: number = 0;
  tax: number = 0;

  constructor() { }

  ngOnInit() {
    this.subs.sink = this.genericDoc$.subscribe(resolve =>{
      this.genericDoc = resolve;
      this.ccyCode = resolve.bl_fi_generic_doc_hdr.doc_ccy;
      resolve.bl_fi_generic_doc_line.filter(l=>l.status==='ACTIVE' && l.txn_type==='STL_MTHD').forEach(item => {
        this.total += <number>item.amount_txn;
        this.tax += <number>item.amount_tax_gst;
      })
    })
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();
    this.gridApi.setRowData(this.createData());
    this.gridApi.sizeColumnsToFit();
  }

  createData() {
    const lineItems = this.genericDoc.bl_fi_generic_doc_line.filter(l=>l.status==='ACTIVE' && l.txn_type==='STL_MTHD').map(item => {
      return {
        item_code: item.item_code,
        item_name: item.item_name,
        item_remarks: item.item_remarks,
        amount_txn: item?.amount_txn
      };
    });

    return lineItems;
  }

  ngOnDestroy() {
    this.subs.unsubscribe;
  }

}
